import { Fragment, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'

import { SET_UNAME } from '../../redux/reducers/site';

export default function EditableInput(props){
    
    const dispatch = useDispatch();
    const [content, setContent] = useState(props.content);
    const setup = useSelector(state => state.site.setup);
    
    const handleKeyPress = evt =>{if (evt.key === 'Enter') { evt.target.blur(); }}
    const [warn, setWarn] = useState('ok');
    
    if(localStorage.user){
        var user = JSON.parse(localStorage.getItem("user"));
    } else {
        window.location.href = '/'+setup.lang+'/login';
    }

    return (
        <Fragment>
            {
            props.inactive?
            <div className='edit inactive'>
                {content}
            </div>
            :
            <Fragment>
            <div contentEditable="true" className={props.inline?'inline':null}
                onInput={(ev)=>handleChange(ev)} 
                onBlur = {(ev)=>onBlurHandle(ev)}
                onKeyDown = {(ev)=>handleKeyPress(ev)}>
            {content}
            </div>
            { warn !=='ok' ? <p className='warn'>{warn}</p> : null}
            </Fragment>
            }
        </Fragment>
    )

function handleChange(ev){
    //console.log(ev.target.innerHTML);
}

function onBlurHandle(evt){
    let cont = sanitize(evt.target.innerText);

    if(content !== cont){
        setContent(cont);
        if(localStorage.uloged) SaveData(cont);
        }
}

function sanitize(html) {
    var doc = document.createElement('div');
    doc.innerHTML = html;
    return doc.innerHTML;
}

function SaveData(cont){
  
    const form = new FormData()
            form.append('lang', setup.lang);
            form.append('value', cont);
            form.append('tag', props.tag);
            form.append('user', user.usr);
            if(props.tid){
                form.append('id', props.tid);
            } else {
                form.append('id', 'none');
            }
  
      const MyInit = { 
                  method: 'POST',
                  body: form
                  };
    fetch(setup.domen+setup.folder+'editableup', MyInit)
      .then(response => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error(response.text()+'Something went wrong ...');
          }
      })
      .then(data => {
          let msg = data.resp;
          if(msg ==='ok'){ 
            setWarn('ok'); 
            user[props.tag] = cont;
            localStorage.setItem('user', JSON.stringify(user));
            dispatch(SET_UNAME(user.fio));
            } else
                    { setWarn(msg); }
      
        })
      .catch(error => {
          //setAllIs({...AllIs, error:error});
      });
  }
}